module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-new-patients-tabs"
  }, [_c('div', {
    staticClass: "custom-new-patients-tabs__container"
  }, [_c('div', {
    staticClass: "custom-new-patients-tabs__tabs"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "custom-new-patients-tabs__tab"
    }, [_c('div', {
      staticClass: "custom-new-patients-tabs__body"
    }, [_c('div', {
      staticClass: "custom-new-patients-tabs__icon"
    }, [_c('object', {
      attrs: {
        "type": "image/svg+xml",
        "data": tab.icon
      }
    })]), _c('div', {
      staticClass: "custom-new-patients-tabs__title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('div', {
      staticClass: "custom-new-patients-tabs__text",
      domProps: {
        "innerHTML": _vm._s(tab.text)
      }
    })]), (i === 0 || i === 1) ? _c('div', {
      staticClass: "custom-new-patients-tabs__arrow"
    }, [_c('Icon', {
      attrs: {
        "name": "arrow"
      }
    })], 1) : _vm._e()])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-887bf66c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-new-patients-tabs/custom-new-patients-tabs.pug
// module id = 660
// module chunks = 1